// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"457":"381cf1e2","513":"1a984dbc","594":"b6109ac9"}[chunkId] + ".js";
};